import { EnrolmentSelectionReplacedEventPayload } from './enrolment-selection-replaced-event-payload';
import { Event } from './event';

export class EnrolmentSelectionReplacedEvent extends Event<EnrolmentSelectionReplacedEventPayload> {}
